import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Stack,
  MenuItem,
  Autocomplete,
  Fab,
  Modal,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Button from "@mui/material/Button";
import { useState, useRef } from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { createFilterOptions } from "@mui/material/Autocomplete";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import { purple } from "@mui/material/colors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import LoadingAnimation from "../../Components/LoadingAnimation";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Pagination from "@mui/material/Pagination";

const DlvStatus = () => {
  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  //TIMEOUT WHEN JWT EXPIRES
  setTimeout(() => {
    LocalstorageHelper.RemoveUserToken();
  }, 3600000);
  const date = new Date();
  const [fromdate, setfromdate] = useState(date);
  const [todate, settodate] = useState(date);
  const [rows, setrows] = useState([]);
  const columns = [
    {
      field: "billno",
      headerClassName: "super-app-theme--header",
      headerName: "Bill No",
      width: 150,
    },
    {
      field: "billdate",
      headerClassName: "super-app-theme--header",
      headerName: "Bill Date",
      width: 120,
    },
    {
      field: "party",
      headerClassName: "super-app-theme--header",
      headerName: "Party",
      width: 500,
    },
    {
      field: "dlvstatus",
      headerClassName: "super-app-theme--header",
      headerName: "Delivery Status",
      width: 150,
    },
    {
      field: "undelivery_reason",
      headerClassName: "super-app-theme--header",
      headerName: "Undelivery Reason",
      width: 200,
    },
    {
      field: "loaddate",
      headerClassName: "super-app-theme--header",
      headerName: "Load Date",
      width: 120,
    },
    {
      field: "loadtime",
      headerClassName: "super-app-theme--header",
      headerName: "Load Time",
      width: 120,
    },
    {
      field: "unloaddate",
      headerClassName: "super-app-theme--header",
      headerName: "Unload Date",
      width: 120,
      type:"time"
    },
    {
      field: "unloadtime",
      headerClassName: "super-app-theme--header",
      headerName: "Unload Time",
      width: 120,
    },
    // ... your other columns
    {
      field: "document",
      headerClassName: "super-app-theme--header",
      headerName: "Document",
      width: 150,
      renderCell: (params) => {
        if (!params.value) return "";
        const blob = new Blob([new Uint8Array(params.value.data)], {
          type: "image/jpeg",
        });
        const url = URL.createObjectURL(blob);
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "8px 16px",
              backgroundColor: "#1976d2",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "4px",
              fontWeight: "bold",
              fontSize: "14px",
              transition: "background-color 0.3s",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#1565c0")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#1976d2")}
          >
            View Document
          </a>
        );
      },
    },
    {
      field: "cndocument",
      headerClassName: "super-app-theme--header",
      headerName: "CN Document",
      width: 150,
      renderCell: (params) => {
        if (!params.value) return "";
        const blob = new Blob([new Uint8Array(params.value.data)], {
          type: "image/jpeg",
        });
        const url = URL.createObjectURL(blob);
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "8px 16px",
              backgroundColor: "#1976d2",
              color: "#fff",
              textDecoration: "none",
              borderRadius: "4px",
              fontWeight: "bold",
              fontSize: "14px",
              transition: "background-color 0.3s",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#1565c0")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#1976d2")}
          >
            View CN Document
          </a>
        );
      },
    },
  ];
  const handleStatusFetch = async (e) => {
    e.preventDefault();
    try {
      const body = { fromdate, todate };
      const response = await fetch("/spare/delivery/dlvstatus", {
        method: "POST",
        headers: { "Content-Type": "application/json", sptoken: userToken },
        body: JSON.stringify(body),
      });
      const jsonData = await response.json();
      setrows(jsonData);
      // console.log(jsonData);
    } catch (err) {
      console.error(err.message);
    }
  };
  return (
    <div>
      <Sidebar
        Title={"DELIVERY STATUS"}
        expandedPanel={"panel2"}
        children={
          <Box
            component="form"
            sx={{
              width: "100%",
            }}
            autoComplete="off"
          >
            <Stack
              columnGap={4}
              direction="row"
              sx={{
                width: 750,
                margin: "auto",
                p: 3,
              }}
              autoComplete="off"
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  inputFormat="DD/MM/YYYY"
                  value={fromdate}
                  onChange={(newValue) => {
                    setfromdate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "30%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  inputFormat="DD/MM/YYYY"
                  value={todate}
                  onChange={(newValue) => {
                    settodate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "30%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <Button
                variant="contained"
                size="small"
                onClick={handleStatusFetch}
              >
                View
              </Button>
            </Stack>
            <Box
              sx={{
                height: 550,
                width: "100%",
                position: "relative",
                mt: "20px",
                // boxShadow: "2px 6px 15px #5a5a5a",
                // border: "0.5px solid black",
                // borderRadius: "5px",
                "& .super-app-theme--header": {
                  backgroundColor: "#3bb9ff",
                  color: "#000",
                },
              }}
            >
              <DataGrid
                sx={{
                  border: "1px solid #000",
                  "& .MuiDataGrid-cell:focus": {
                    outline: "2px solid red", // Change this to the desired color
                    backgroundColor: "gray",
                    color: "white",
                  },
                }}
                rowHeight={25}
                headerHeight={40}
                showColumnRightBorder={true}
                rows={rows}
                columns={columns}
                getRowId={(row) => row.loadid}
              />
            </Box>
          </Box>
        }
      />
      {/* <FooterElement /> */}
      {redirectToLoginPage()}
    </div>
  );
};

export default DlvStatus;
